import { SearchParams } from '@/types/common'
import { InterfaceID } from '@/types/interface'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const interfaceApi = {
  getAll(searchParams: SearchParams = {}) {
    const url = '/api/interface'
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getAllV2(searchParams: SearchParams = {}) {
    const url = '/api/interface' // New API v2.
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getSensorsByInterface(interfaceId: number, searchParams: SearchParams = {}) {
    const url = `api/sensor/get-by-interface/${interfaceId}`
    return axiosClient.get(url + queryStringify(searchParams))
  },
  resetInterface(interfaceId: string, confirmDelete: string) {
    const url = `/api/setup/${interfaceId}/reset`
    return axiosClient.post(
      url,
      { ConfirmDelete: confirmDelete },
      { validateStatus: (status) => status === 200 }
    )
  },

  getById(id?: string) {
    const url = `/api/interface/${id}`
    return axiosClient.get(url)
  },

  getByCountry() {
    const url = `/api/country`
    return axiosClient.get(url)
  },

  getByTimeZoneCountry(searchParams: SearchParams = {}) {
    const url = `/api/timezone/get-by-country`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getAutoSync() {
    const url = `/api/autosyncdata/manual-sync-data-interface`
    return axiosClient.get(url)
  },

  update(payload: InterfaceID) {
    const url = '/api/interface'
    return axiosClient.put(url, payload)
  },
  getByOrgId() {
    const url = `api/interface/getbyorganization`
    return axiosClient.get(url)
  },
  getMyInterface() {
    const url = '/api/interface' // New API v2.
    return axiosClient
      .get(url + queryStringify({ PageSize: 0 }))
      .then((res) => {
        const data =
          res?.data?.data?.map((item: any) => {
            return {
              id: item.id,
              name: item.interfaceName,
              customName: item.interfaceCustomName,
              status: item.status,
              state: item.state,
              type: item.type,
              organizations: item.organizations,
            }
          }) || []
        return { data }
      })
  },
  getHeartbeat(interfaceId: string) {
    const url = `/api/interface/${interfaceId}/heartbeat`
    return axiosClient.get(url)
  },
}

export default interfaceApi
